"use client";

import Helper from "@/utils/helper";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

import { BrandCollectionJson, BrandJson } from "@/types/Brand.type";

import Button from "@/components/ui/Button";
import LoadMore from "@/components/LoadMore";
import InputBorder from "@/components/ui/InputBorder";
import Drawer, { DrawerProps } from "@/components/Drawer";
import { CheckTagIcon, SearchIcon } from "@/components/icons";
import FilterSelect from "~components/product/ProductFilterSelect";

export default function ProductFilterBrandMobile({
	drawerProps,
	brands,
	defaultValues,
	isLoading,
	onSubmit,
	onSearch,
	onLoadMore,
}: {
	onSubmit: (datas: string[]) => void;
	drawerProps: DrawerProps;
	brands: BrandCollectionJson;
	defaultValues: string | undefined;
	onLoadMore?: () => void;
	onSearch?: (keyword: string) => void;
	isLoading: boolean;
}) {
	const { control, handleSubmit } = useForm({
		defaultValues: {
			key: "",
		},
	});

	const [values, setVales] = useState<string[]>([]);
	const handelSearchBrand = useDebouncedCallback((key) => {
		onSearch?.(key);
	}, 400);

	useEffect(() => {
		if (defaultValues?.length) {
			setVales(defaultValues?.split(","));
		} else {
			setVales([]);
		}
	}, [defaultValues]);

	return (
		<>
			<Drawer
				classNameHeader="mt-[30px] mb-[15px] flex items-center justify-center"
				title={
					<h5 className="flex-1 h-full flex items-center font-bold justify-center text-base">
						Thương hiệu
					</h5>
				}
				{...drawerProps}>
				<div className="  relative  h-full ">
					<form
						onChange={handleSubmit((data) => handelSearchBrand(data.key))}
						className="flex-shrink-0 mb-4 flex items-center justify-center border border-gray-400 rounded-sm mx-4">
						<SearchIcon className="min-w-5 ml-2" />
						<InputBorder
							name="key"
							control={control}
							className="border-none"
							placeholder="Tìm kiếm"
						/>
					</form>
					<LoadMore
						onLoadMore={() => onLoadMore?.()}
						total={brands.total}
						totalCurrent={brands.items.length}
						loading={isLoading}
						className="flex flex-col gap-2 px-4 flex-1 h-full overflow-auto  pb-80">
						<FilterSelect
							onChange={(data) => {
								setVales(data.map((bra) => bra.handle));
							}}
							defaultValue={Helper.handleFilterActive<BrandJson>(
								values.join(","),
								brands.items,
								"handle"
							)}
							isMutiple
							dataSource={brands.items}
							renderItem={(item, state) => {
								return (
									<li className="flex items-center justify-between text-base leading-8">
										<span>{item.title}</span>
										{state.some((it) => it.handle === item.handle) && (
											<CheckTagIcon className="h-6 w-6 min-w-6" />
										)}
									</li>
								);
							}}
						/>
					</LoadMore>
					<div className="  sticky  bg-white   bottom-[50px] left-0 right-0 p-4">
						<Button
							mode="main"
							label="Hoàn tất"
							className=" flex-shrink-0 text-sm w-full h-[34px] rounded-sm z-[5001]   "
							onClick={() => {
								onSubmit(values);
								drawerProps.onClose();
							}}
						/>
					</div>
				</div>
			</Drawer>
		</>
	);
}
